import React, { useState } from 'react';
import './index.scss';
import { toast } from 'react-toastify';
import axios from 'axios';
import { getStorageItem } from "../../../../utils/sessionStorage";

const AdminCreateAdd = () => {
    const [loading, setLoading] = useState(false);
    const [uploading, setUploading] = useState(false);
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [isCompulsory, setIsCompulsory] = useState(false);
    const [pitch, setPitch] = useState(false);
    const [url, setUrl] = useState('');
    const [file, setFile] = useState(null);
    const [fileName, setFileName] = useState('');
    const [dealId, setDealId] = useState(null);
    // const [adUrl, setAdUrl] = useState(null);

    const accessToken = getStorageItem("token");

    // Function to handle file upload to Cloudinary
    const handleFileUpload = async () => {
        if (!file) {
            toast.error('No file selected');
            return false; // Return false if no file is selected
        }

        setUploading(true);
        const formData = new FormData();
        formData.append('file', file);
        formData.append('upload_preset', 'uploads'); // Use correct preset

        try {
            // Cloudinary API URL
            const cloudinaryURL = 'https://api.cloudinary.com/v1_1/dndkskewk/video/upload';
            const response = await axios.post(cloudinaryURL, formData);

            // Check if response contains secure_url
            if (response.data && response.data.secure_url) {
                setUrl(response.data.secure_url);
                toast.success('Video uploaded successfully!');
                return true; // Return true if video uploaded successfully
            } else {
                throw new Error('Failed to obtain video URL from response');
            }
        } catch (error) {
            console.error('Error uploading video:', error);
            toast.error('Failed to upload video');
            setUploading(false);
            return false; // Return false if upload fails
        } finally {
            setUploading(false);
        }
    };

    // Function to handle ad creation
    const handleAdCreation = async (e) => {
        e.preventDefault();
        setLoading(true);

        // If file is selected but url is empty, upload the file
        if (file && !url) {
            const uploadSuccess = await handleFileUpload();
            if (!uploadSuccess) {
                setLoading(false);
                return;
            }
        }

        // Ensure the URL has been set successfully
        if (!url) {
            toast.error('No URL for video. Failed to upload video.');
            setLoading(false);
            return;
        }

        // Create data object for ad creation
        const data = {
            title,
            description,
            url,
            isCompulsory,
            dealId,
            pitch
        };

        // Validate input
        if (!title || !description || !url) {
            toast.error('Incomplete information');
            setLoading(false);
            return;
        }

        // Proceed with ad creation request
        try {
            const response = await axios.post(`${global.config.ROOTURL.prod}/ads/create-ad`, data, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Headers': '*',
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Methods': '*',
                },
            });
            console.log('Advertisement created successfully:', response.data);
            toast.success('Advertisement created successfully!');
        } catch (err) {
            console.error('Error creating advertisement:', err);
            toast.error('Failed to create advertisement');
        } finally {
            // Reset form states and loading status
            setLoading(false);
            setTitle('');
            setDescription('');
            setUrl('');
            setFile(null);
            setFileName('');
            setDealId(null);
            setIsCompulsory(false);
        }
    };

    // Handle file change
    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        if (selectedFile) {
            setFile(selectedFile);
            setFileName(selectedFile.name);
        }
    };

    return (
        <div className='ad-creation-wrapper'>
            <h1 className='ad-creation__title'>Upload Videos</h1>
            <form className='ad-creation__form' onSubmit={handleAdCreation}>
                <div>
                    <label htmlFor="ad-title" className='ad-creation__form-label'>Title</label>
                    <input id="ad-title" type="text" className='ad-creation__form-input' placeholder='Weekend Highlights' value={title} onChange={(e) => setTitle(e.target.value)} required />
                </div>
                <div>
                    <label htmlFor="ad-description" className='ad-creation__form-label'>Description</label>
                    <textarea id="ad-description" className='ad-creation__form-textarea' placeholder='Enter a description...' value={description} onChange={(e) => setDescription(e.target.value)} required />
                </div>
                {/* <div>
                    <label htmlFor="ad-url" className='ad-creation__form-label'>URL</label>
                    <input id="ad-url" type="url" className='ad-creation__form-input' placeholder='Ad Url' value={adUrl} onChange={(e) => setAdUrl(e.target.value)} required />
                </div> */}
                <div>
                    <label htmlFor="ad-checkbox" className='ad-creation__form-label'>Make compulsory</label>
                    <input id="ad-checkbox" type="checkbox" className='ad-creation__form-checkbox' checked={isCompulsory} onChange={() => setIsCompulsory(!isCompulsory)} />
                </div>
                <div>
                    <label htmlFor="deal-id" className='ad-creation__form-label'>Deal Id</label>
                    <input id="deal-id" type="text" className='ad-creation__form-input' placeholder="Enter deal id" value={dealId} onChange={(e) => setDealId(e.target.value)} />
                </div>
                <div>
                    <label htmlFor="ad-checkbox1" className='ad-creation__form-label'>Show on pitch</label>
                    <input id="ad-checkbox1" type="checkbox" className='ad-creation__form-checkbox' checked={pitch} onChange={() => setPitch(!pitch)} />
                </div>
                <div>
                    <label htmlFor="ad-file" className="ad-creation__form-file-label">
                        <div>
                            <span>Browse files...</span>
                            <input id="ad-file" type="file" className='ad-creation__form-file' accept="video/*" onChange={handleFileChange} />
                            {fileName && <span>{fileName}</span>}
                        </div>
                    </label>
                </div>
                <div>
                    <button type="submit" className={`${loading || uploading ? 'ad-creation-form-submit--disabled' : 'ad-creation-form-submit--active'}`}>
                        Submit
                    </button>
                </div>
            </form>
        </div>
    );
};

export default AdminCreateAdd;
